import { Text } from '@nimbus-ds/components';
import {
  PaymentProvidersCode,
  muvemPagoOrPagoNubeIds,
  customPaymentsIds,
} from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { FEATURE_ONLY_NUVEM_PAGO } from 'App/features';
import { useGetCountry, useGetPlan } from 'domains/Auth/hooks';
import { useBillingPlans } from 'domains/Billing/BillingPlans/hooks';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';
import { TRANSLATE_PAYMENT_PREFIX } from '../../components';

interface GetCptFeeProps {
  providerId: string;
  customPaymentCpt: string;
}

export const useGetCptFee = () => {
  const { plansList, isLoading, isSuccess } = useBillingPlans();
  const { transactionFee: cpt, isNext, isEvolucion, isFreePlan } = useGetPlan();
  const t = useTranslationPayments(TRANSLATE_PAYMENT_PREFIX);
  const storeCountry = useGetCountry();

  const getCptFee = ({ providerId, customPaymentCpt }: GetCptFeeProps) => {
    const isNuvemPagoEnterpriseNext =
      PaymentProvidersCode.nuvemPago === providerId && isNext;

    const isNuvemPagoEnterpriseEvolucion =
      PaymentProvidersCode.nuvemPago === providerId && isEvolucion;

    if (isNuvemPagoEnterpriseEvolucion) {
      return <Text color="success-textLow">{t('cptToNegotiate')}</Text>;
    }

    if (isNuvemPagoEnterpriseNext) {
      return <Text color="success-textLow">{t('freeCpt')}</Text>;
    }

    if (muvemPagoOrPagoNubeIds.includes(providerId)) {
      return <Text color="success-textLow">{t('freeCpt')}</Text>;
    }

    if (customPaymentsIds.includes(providerId)) {
      return <Text>{`${customPaymentCpt}%`}</Text>;
    }

    if (isFreePlan) {
      const freePlanCpt = getFreePlanCpt();
      if (freePlanCpt) {
        return freePlanCpt;
      }
    }

    return <Text>{`${cpt}%`}</Text>;
  };

  const getFreePlanCpt = () => {
    const storeCountriesThatShowNextPlanCpt = ['AR', 'BR', 'MX'];

    if (storeCountriesThatShowNextPlanCpt.includes(storeCountry)) {
      if (isLoading) {
        return <Text.Skeleton />;
      }

      if (isSuccess) {
        //success loading plans
        const plan = plansList.find(
          ({ featureKeys }) => !featureKeys[FEATURE_ONLY_NUVEM_PAGO],
        );
        if (plan) {
          return <Text>{`${plan.fee.value}%`}</Text>;
        }
      }
    }
  };

  return {
    getCptFee,
  };
};
